export default __webpack_public_path__ + "b27a7591647e8fa3b097942a9837bdd6.svg";